import "bootstrap/dist/css/bootstrap.min.css";
import React, { useState, lazy, Suspense } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import { Container, Row, Col } from "react-bootstrap";
import "./App.css";
import Loader from "../utils/Loader";
import NoIndex from "./NoIndex";

// Lazy-loaded components
const Dashboard = lazy(() => import("./Dashboard/Dashboard"));
const Header = lazy(() => import("./Shared/Header"));
const Sidebar = lazy(() => import("./Shared/Sidebar"));
const Footer = lazy(() => import("./Shared/Footer"));
const UserList = lazy(() => import("./UserList/UserList"));
const ProtectedRoute = lazy(() => import("./Auth/ProtectedRoute"));
const ArticleFrobes = lazy(() => import("./templates/ArticleFrobes"));
const ArticleCXO = lazy(() => import("./templates/ArticleCXO"));
const Randlesham = lazy(() => import("./templates/Randlesham"));
const WebTemplate = lazy(() => import("./website/WebTemplate"));
const About = lazy(() => import("./website/About"));
const Speaker = lazy(() => import("./website/Speaker"));
const Portfolio = lazy(() => import("./website/Portfolio"));
const Contact = lazy(() => import("./website/Contact"));
const LongFormPost = lazy(() => import("./linkedin_template/LongFormPost"));
const ShortPost = lazy(() => import("./linkedin_template/ShortPost"));
const GoogleTemplate = lazy(() => import("./templates/GoogleTemplate"));
const MsnArticle = lazy(() => import("./templates/MsnArticle"));
const PixArticle = lazy(() => import("./templates/PixArticle"));
const Kget = lazy(() => import("./templates/Kget"));
const Digitaljournal = lazy(() => import("./templates/Digitaljournal"));
const Home = lazy(() => import("./report/Home"));
const Pricing = lazy(() => import("./pricing/Pricing"));
const PricingList = lazy(() => import("./pricingList/PricingList"));

function AdminApp() {
  const [isSidebarVisible, setIsSidebarVisible] = useState(false);
  const toggleSidebar = () => setIsSidebarVisible(!isSidebarVisible);
  
  // Render /admin/templates as pure standalone (no layout at all)
  const location = useLocation();
  // if (location.pathname === "/admin/templates/forbes") {
  if (location.pathname.startsWith("/templates/forbes")) {
    return (
        <Routes>
          <Route
            path="forbes/:id"
            element={
              <ProtectedRoute>
                <ArticleFrobes />
              </ProtectedRoute>
            }
          />
        </Routes>
    );
  } else if (location.pathname.startsWith("/templates/cxo")) {
    return (
      <Routes>
        <Route
          path="cxo/:id"
          element={
            <ProtectedRoute>
              <ArticleCXO />
            </ProtectedRoute>
          }
        />
      </Routes>
    );
  } else if (location.pathname.startsWith("/templates/randlesham")) {
    return (
      <Routes>
        <Route
          path="randlesham/:id"
          element={
            // <ProtectedRoute>
              <>
                <NoIndex />
                <Randlesham />
              </>
            // </ProtectedRoute>
          }
        />
      </Routes>
    );
  } else if (location.pathname.startsWith("/templates/msn")) {
    return (
      <Routes>
        <Route
          path="msn/:id"
          element={
            <ProtectedRoute>
              <MsnArticle />
            </ProtectedRoute>
          }
        />
      </Routes>
    );
  } else if (location.pathname.startsWith("/templates/pix")) {
    return (
      <Routes>
        <Route
          path="pix/:id"
          element={
            <ProtectedRoute>
              <PixArticle />
            </ProtectedRoute>
          }
        />
      </Routes>
    );
  } else if (location.pathname.startsWith("/templates/kget")) {
    return (
      <Routes>
        <Route
          path="kget/:id"
          element={
            // <ProtectedRoute>
              <>
                <NoIndex />
                <Kget />
              </>
            // </ProtectedRoute>
          }
        />
      </Routes>
    );
  } else if (location.pathname.startsWith("/templates/digitaljournal")) {
    return (
      <Routes>
        <Route
          path="digitaljournal/:id"
          element={
            // <ProtectedRoute>
              <>
                <NoIndex />
                <Digitaljournal />
              </>
            // </ProtectedRoute>
          }
        />
      </Routes>
    );
  } else if (location.pathname.startsWith("/linkedin/longformpost")) {
    return (
      <Routes>
        <Route
          path="longformpost/:id"
          element={
            // <ProtectedRoute>
            <>
              <NoIndex />
              <LongFormPost />
            </>
            // </ProtectedRoute>
          }
        />
      </Routes>
    );
  } else if (location.pathname.startsWith("/linkedin/shortpost")) {
    return (
      <Routes>
        <Route
          path="shortpost/:id"
          element={
            // <ProtectedRoute>
              <>
                <NoIndex />
                <ShortPost />
              </>
            // </ProtectedRoute>
          }
        />
      </Routes>
    );
  } else if (location.pathname.startsWith("/website/about")) {
    return (
        <Routes>
          <Route
            path="about/:id"
            element={
              // <ProtectedRoute>
                <About />
              // </ProtectedRoute>
            }
          />
        </Routes>
    );
  } else if (location.pathname.startsWith("/website/speaker")) {
    return (
        <Routes>
          <Route
            path="speaker/:id"
            element={
              // <ProtectedRoute>
                <Speaker />
              // </ProtectedRoute>
            }
          />
        </Routes>
    );
  } else if (location.pathname.startsWith("/website/portfolio")) {
    return (
        <Routes>
          <Route
            path="portfolio/:id"
            element={
              // <ProtectedRoute>
                <Portfolio />
              // </ProtectedRoute>
            }
          />
        </Routes>
    );
  } else if (location.pathname.startsWith("/website/contact")) {
    return (
        <Routes>
          <Route
            path="contact/:id"
            element={
              // <ProtectedRoute>
                <Contact />
              // </ProtectedRoute>
            }
          />
        </Routes>
    );
  } else if (location.pathname.startsWith("/website")) {
    return (
        <Routes>
          <Route
            path=":id"
            element={
              // <ProtectedRoute>
                <WebTemplate />
              // </ProtectedRoute>
            }
          />
        </Routes>
    );
  } else if (location.pathname.startsWith("/report")) {
    return (
      <Suspense fallback={<div className="p-4"><Loader /></div>}>
        <Routes>
          <Route
            path=":id"
            element={
              // <ProtectedRoute>
                <Home />
              // </ProtectedRoute>
            }
          />
        </Routes>
      </Suspense>
    );
  } else if (location.pathname.startsWith("/templates/google")) {
    return (
        <Routes>
          <Route
            path="google/:id"
            element={
              <ProtectedRoute>
                <GoogleTemplate />
              </ProtectedRoute>
            }
          />
        </Routes>
    );
  }

  // For all other routes — normal layout
  return (
    <div style={{ background: "#191A23" }}>
      <Suspense fallback={<div className="p-4"><Loader /></div>}>
        <Container className="px-0 overflow-hidden" fluid>
          <Row>
            <Col md={12}>
              <Header toggleSidebar={toggleSidebar} />
            </Col>
          </Row>
          <Container className="px-0 d-flex" fluid>
            <Sidebar className={`${isSidebarVisible ? "icons-show" : ""} d-block`} />
            <div className={isSidebarVisible ? "icons-show outer-panel pt-0" : "outer-panel pt-0"}>
              <div className="main-panel py-2 px-3">
                <Routes>
                  <Route
                    path="/"
                    element={<ProtectedRoute><Dashboard /></ProtectedRoute>}
                  />
                  <Route
                    path="users"
                    element={<ProtectedRoute><UserList /></ProtectedRoute>}
                  />
                  <Route
                    path="pricing"
                    element={<ProtectedRoute><Pricing /></ProtectedRoute>}
                  />
                  <Route
                    path="pricing-list"
                    element={<ProtectedRoute><PricingList /></ProtectedRoute>}
                  />
                </Routes>
              </div>
              <Footer />
            </div>
          </Container>
        </Container>
      </Suspense>
    </div>
  );
}

export default AdminApp;
